import React from 'react';
import { Shield } from 'lucide-react';
import './Company.css';

const Company = () => {
  return (
    <section className="company section" id="company" data-testid="company-section">
      <div className="container">
        <div className="company-content">
          <div className="company-logo">
            <span className="company-logo-icon">VS</span>
          </div>
          <h2 className="company-name">VantaSignal Technologies LLC</h2>
          <p className="company-tagline">AI Communication Firewall</p>
          <p className="company-description">
            Founded in 2026 to provide governance infrastructure<br />
            for AI-generated communication.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Company;
